<template>
<md-card>
    <header-form title="CADASTRAR DE PLANOS" :rota="{name: 'planosRead'}" tooltip="Lista de Planos" />

    <form @submit.prevent="create">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.porcentagem }">
                        <label>PORCENTAGEM</label>
                        <md-input v-model="dados.porcentagem" type="text" class="uppercase" v-mask="['#', '#,#', '#,##', '##,##', '###,##']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.porcentagem">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.porcentagem" class="validErro"> {{ errors.porcentagem[0] }}</div>
                </div>

                 <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.valor }">
                        <label>VALOR</label>
                        <md-input v-model="dados.valor" type="text" class="uppercase" v-money> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.valor">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.valor" class="validErro"> {{ errors.valor[0] }}</div>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {}
        }
    },
    mixins: [Notify],
    methods: {
        create() {
            this.$http.post(this.$urlAPI + 'planos', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'planosRead'
                        })
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>
